import type { ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="container max-w-6xl mx-auto p-5">
      {children}
    </div>
  );
}
